/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUploadAssetUrlResponse
 */
export interface GetUploadAssetUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUploadAssetUrlResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof GetUploadAssetUrlResponse
     */
    fileName: string;
}

export function GetUploadAssetUrlResponseFromJSON(json: any): GetUploadAssetUrlResponse {
    return GetUploadAssetUrlResponseFromJSONTyped(json, false);
}

export function GetUploadAssetUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUploadAssetUrlResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
        'fileName': json['fileName'],
    };
}

export function GetUploadAssetUrlResponseToJSON(value?: GetUploadAssetUrlResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'fileName': value.fileName,
    };
}


